import React from 'react'
import IotHeader from '../../components/IotDevice/IotHeader'
import IoTDeviceTable from '../../components/IotDevice/IotListing'
function IotDashboard() {
  return (
    <div>
        <div className='mb-22 bg-white'>
      <IotHeader />

        </div >
        <div className='justify-items-center'>
      <IoTDeviceTable/>

        </div>
    </div>
  )
}

export default IotDashboard
